/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_OpenapiInputs */

const en_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI`)
};

const ar_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI`)
};

const bn_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI`)
};

const de_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI`)
};

const es_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API abierta`)
};

const fr_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI`)
};

const pt_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API aberta`)
};

const zh_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI`)
};

const tr_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI`)
};

const ru_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI`)
};

const pl_svchip_openapi = /** @type {(inputs: Svchip_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OtwarteAPI`)
};

/**
* | output |
* | --- |
* | "OpenAPI" |
*
* @param {Svchip_OpenapiInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_openapi = /** @type {((inputs?: Svchip_OpenapiInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_OpenapiInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_openapi(inputs)
	if (locale === "bn") return bn_svchip_openapi(inputs)
	if (locale === "de") return de_svchip_openapi(inputs)
	if (locale === "es") return es_svchip_openapi(inputs)
	if (locale === "fr") return fr_svchip_openapi(inputs)
	if (locale === "pt") return pt_svchip_openapi(inputs)
	if (locale === "zh") return zh_svchip_openapi(inputs)
	if (locale === "tr") return tr_svchip_openapi(inputs)
	if (locale === "ru") return ru_svchip_openapi(inputs)
	if (locale === "pl") return pl_svchip_openapi(inputs)
	return en_svchip_openapi(inputs)
});